export default __webpack_public_path__ + "static/media/gallery1.1037bf5e.png";